export default __webpack_public_path__ + "static/media/chat.31af89e0.svg";